import { render, staticRenderFns } from "./input-file.vue?vue&type=template&id=541cd2b2&scoped=true&"
import script from "./input-file.vue?vue&type=script&lang=js&"
export * from "./input-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cd2b2",
  null
  
)

export default component.exports